import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { ACTION, MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';
import LegalDetailsList from './submodule/list';

const LegalDetails: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.miscellaneous}
				configResourceName={MISCELLANEOUS_RESOURCES.legalDetails}
				configActionName={ACTION.getLegalDetailsOfUser}
				path={`${path}/list`}
				component={LegalDetailsList}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default LegalDetails;
